import { render, staticRenderFns } from "./MemoryAdd.vue?vue&type=template&id=0acc36b0&scoped=true"
import script from "./MemoryAdd.vue?vue&type=script&lang=js"
export * from "./MemoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc36b0",
  null
  
)

export default component.exports